'use client'

import {
  LINK_COPY_SUCCESS_MESSAGE,
  APP_SCHEME,
  buildKakaoLinkPath,
} from '@/shared/lib'

export interface ICarStoryShareMeta {
  url: string
  title: string
  description: string
  imageUrl: string
  kakaoTemplateId: number
}

interface IUseCarStoryShareParams {
  shareMeta: ICarStoryShareMeta
}

const KAKAO_UNAVAILABLE_MESSAGE =
  '카카오 공유를 사용할 수 없어요. 링크를 복사해 주세요.'

const useCarStoryShare = ({ shareMeta }: IUseCarStoryShareParams) => {
  const { url, title, description, imageUrl, kakaoTemplateId } = shareMeta

  const handleKakaoShare = () => {
    // Kakao SDK 미로드/광고 차단 환경 가드
    if (!window.Kakao?.Share) {
      alert(KAKAO_UNAVAILABLE_MESSAGE)
      return
    }

    window.Kakao.Share.sendCustom({
      templateId: kakaoTemplateId,
      templateArgs: {
        url: buildKakaoLinkPath(url),
        img: imageUrl,
        title: title,
        dsc: description,
      },
      installTalk: true,
    })
  }

  const handleCopyLink = async () => {
    // 표준 Clipboard API 우선 시도 → 미지원 환경에서만 execCommand 폴백
    try {
      await navigator.clipboard.writeText(url)
      alert(LINK_COPY_SUCCESS_MESSAGE)
      return
    } catch {
      // 폴백으로 진행
    }

    const textarea = document.createElement('textarea')
    textarea.value = url
    textarea.readOnly = true
    textarea.style.position = 'fixed'
    textarea.style.left = '-9999px'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
    alert(LINK_COPY_SUCCESS_MESSAGE)
  }

  const handleShareMore = () => {
    location.href = APP_SCHEME.OPEN_SHARE_MORE(url)
  }

  return {
    handleKakaoShare,
    handleCopyLink,
    handleShareMore,
  }
}

export default useCarStoryShare
